<template>
  <div class="im-property">
    <div class="im-property__wrapper">
      <div class="im-property__header">
        <div class="im-property__title">Имущество</div>
        <div class="im-property__close" @click="close">
          <svg>
            <use xlink:href="#icon-close"></use>
          </svg>
        </div>
      </div>
      <template v-if="!hideItems">
        <div v-if="!visibleItems.length" class="im-property__empty">У вас ничего нет.</div>
        <div v-else class="im-property__items" >
          <div class="im-property__items-wrapper">
            <div class="im-property-item" v-for="(item, index) in visibleItems"
                 :key="index"
                 @click="toogle(item, true)"
            >
              <div class="im-property-item__image">
                <img :src="item.Image" :alt="item.FishkaName">
                <div class="im-property-item__count">x {{ item.Count }}</div>
              </div>
              <div class="im-property-item__title">{{ item.FishkaName }}</div>
            </div>
          </div>
        </div>
      </template>
      <div class="im-property-item-info" v-if="hideItems">
        <div class="im-property-item-info__close" @click="toogle">
          <svg>
            <use xlink:href="#icon-close"></use>
          </svg>
        </div>
        <div class="im-property-item-info__image">
          <img :src="this.item.Image" alt="">
        </div>
        <div class="im-property-item-info__title">{{ this.item.FishkaName }}</div>
        <div class="im-property-item-info__spred">{{ this.item.Sec_Name }}</div>
        <div class="im-property-item-info__desc" v-html="item.Text"></div>
        <textarea class="im-property-item-info__comment" ref="textarea"></textarea>
        <div class="im-property-item-info__btn" @click="give">Подарить</div>
      </div>
      <a href="/community/gorod/main/?do=shop" class="im-property__go-to-shop">Перейти в магазин и выбрать
        другие подарки
      </a>
    </div>
  </div>
</template>

<script>
  import ADL from "../../../../../../ADL";

  const adl = new ADL();

  export default {
    name: 'Property',
    props: {
      userId: {
        type: Number,
        default: null
      }
    },
    data() {
      return {
        hideItems: false,
        item: {
          src: '',
          title: '',
          desc: ''
        },
        items: []
      };
    },
    computed: {
      visibleItems: function () {
        return this.items.filter(function (item) {
          return item.RemoveBlack === "0";
        })
      }
    },
    mounted() {
      this.init();
    },
    methods: {
      async init(){
        const params = {
          url: '/ajax.php',
          method: 'post',
          data: 'c=classStaff&m=inPrivat&user_id=' + this.userId
        };
        try {
          const response = await adl.oldAjaxHack(params);
          if (response.data.Error) {
            alert(response.data.Error);
          } else {
            this.items = response.data.Fishki;
          }
        } catch (e) {
          console && console.error(e);
          alert('Ошибка. Попробуйте позже');
        }
      },
      async give() {
        const jsreq = new Subsys_JsHttpRequest_Js();
        const params = {
          url: '/ajax.php',
          method: 'post',
          "data": jsreq._hash2query({ // ! ALARM ! там внутри старый escape() который отправляет кириллицу как надо
            'c': 'classStaff',
            'm': 'inPrivat',
            'do': 'set',
            'user_id': this.userId,
            'fishka_id': this.item.FishkaId,
            'comment': this.$refs.textarea.value,
          })
        };
        try {
          const response = await adl.oldAjaxHack(params);
          if (response.data.Error) {
            alert(response.data.Error);
          } else {
            this.items = response.data.Fishki;
            this.toogle();
            this.$store.dispatch('updateMessages');
          }
        } catch (e) {
          console && console.error(e);
          alert('Ошибка. Попробуйте позже');
        }
      },
      toogle(item, value) {
        if (value && value === true) {
          this.hideItems = true;
          this.item = item;
        } else {
          this.hideItems = false;
        }
      },
      close() {
        this.$emit('close');
      }
    }

  };
</script>

<style lang="scss">
  .im-property {
    box-sizing: border-box;
    background: #FFF;
    border: 1px solid #D6D6D6;
    padding: 10px;
    width: 212px;
    height: calc(100% + 2px);
    position: absolute;
    top: -1px;
    left: -212px;

    &__wrapper {
      display: flex;
      flex-direction: column;
    }

    &__close {
      position: absolute;
      top: 10px;
      right: 10px;
      cursor: pointer;

      svg {
        fill: #E54545;
        width: 10px;
        height: 10px;
      }
    }

    &__title {
      font-weight: bold;
      font-size: 11px;
      line-height: 16px;
      letter-spacing: 0.04em;
      text-transform: uppercase;
      color: #0086E5;
    }

    &__empty{
      margin: 8px 0;
    }

    &__items {
      border: 1px solid #D6D6D6;
      margin: 8px 0;
    }

    &__items-wrapper {
      display: flex;
      flex-wrap: wrap;
      overflow: hidden;
      overflow-y: auto;
      padding: 0 3px 0 0;
      max-height: 364px;
      width: calc(100% + 5px);

      &::-webkit-scrollbar {
        width: 4px;

        &-track {
          background: #FFFFFF;
        }

        &-thumb {
          background: #C6CBD0;
          border-radius: 2px;
        }
      }
    }

    &__go-to-shop {
      margin: 8px 0;
      color: #242A32;
    }
  }

  .im-property-item {
    box-sizing: border-box;
    overflow: hidden;
    border-right: 1px solid #D6D6D6;
    border-bottom: 1px solid #D6D6D6;
    padding: 10px;
    width: 50%;
    text-align: center;
    cursor: pointer;

    &__image {
      img {
        width: 100%;
        max-width: 60px;
      }
    }

    &__title {
      font-size: 12px;
      height: 24px;
    }
  }

  .im-property-item-info {
    box-sizing: border-box;
    background: #FFF;
    border: 1px solid #D6D6D6;
    padding: 10px;
    width: 100%;
    position: relative;
    margin: 8px 0;

    &__close {
      position: absolute;
      top: 10px;
      right: 10px;
      cursor: pointer;

      svg {
        fill: #E54545;
        width: 10px;
        height: 10px;
      }
    }

    &__btn {
      background: #1588E2;
      border: 1px solid #D6D6D6;
      border-radius: 2px;
      padding: 12px 24px;
      font-size: 13px;
      line-height: 15px;
      text-align: center;
      color: #FFF;
      cursor: pointer;
    }
  }


</style>